export default function setCssCustomProperty(
    propertyName: string,
    value: string
) {
    //console.log("set css " + propertyName + " " + value);
    return document.documentElement.style.setProperty(propertyName, value);
}
